<template>
    <VueSlickCarousel v-bind="settings">
        <div>
            <ProjectCard />
        </div>
        <div>
            <ProjectCard />
        </div>
        <div>
            <ProjectCard />
        </div>
        <div>
            <ProjectCard />
        </div>
    </VueSlickCarousel>
</template>

<script>
import ProjectCard from "@/components/projects/ProjectCard"
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    components: { VueSlickCarousel, ProjectCard },
    name: "projects-list",
    data() {
        return {
            settings: {
                "slidesToShow": 3,
                "slidesToScroll": 1,
                "initialSlide": 0,
                "arrows": true,
                "infinite": false,
                "responsive": [
                    {
                        "breakpoint": 1023,
                        "settings": {
                            "slidesToShow": 2,
                            "slidesToScroll": 2,
                            "centerMode": true,
                            "arrows": false,
                        }
                    },
                    {
                        "breakpoint": 767,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                            "centerPadding": "20px",
                            "centerMode": true,
                            "arrows": false,
                        }
                    },
                ]
            }
        }
    },
    
}
</script>

<style lang="scss" scoped>

</style>